module.exports = __webpack_public_path__ + "static/media/19.Lion Roar.ada59ba2.mp3";